<template>
  <app-modal :width="modalWidth" name="benefits-modal" @before-open="beforeOpen" hide-footer>
    <template v-slot:title>
      <div>
        <i class="fal fa-heart mr-1" style="color: #ffffff;"></i>
        {{ $t('notification.benefits.label') }}
      </div>
    </template>
    <div v-if="!selected" class="benefits-container">
      <div class="benefits-top">
        <div @click="setSelected(n)" class="item fade-in-up" :class="`item-${n}`" v-for="n in top" :key="n">
          <div class="image">
            <img :src="`/images/benefit-${n}.svg`" alt="image">
          </div>
          <p>{{$t(`notification.benefits.sections.${n}`)}}</p>
        </div>
      </div>
      <div class="benefits-bottom">
        <div @click="setSelected(n)" class="item fade-in-up" :class="`item-${n}`" v-for="n in bottom" :key="n">
          <div class="image">
            <img :src="`/images/benefit-${n}.svg`" alt="image">
          </div>
          <p>{{$t(`notification.benefits.sections.${n}`)}}</p>
        </div>
      </div>
    </div>
    <div v-else class="selected-container">
      <img class="fade-in-up" :width="imgSize.width" :height="imgSize.height" :src="getGIFUrl(nameGIF[selected])" :alt="`image-gif-${nameGIF[selected]}`">
      <button @click="setSelected(0)" class="btn btn-sm btn-outline-secondary">
        <i class="fa fa-reply" aria-hidden="true" />
        {{$t(`app.back`)}}
      </button>
    </div>
  </app-modal>
</template>
<script>
import AppModal from '@/components/app-modal/';
import { GIF_URL } from '@/app-constant';

export default {
  name: 'BenefitsModal',
  components: {
    AppModal,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      top: [1, 2, 3, 4],
      bottom: [5, 6, 7],
      selected: 0,
      nameGIF: {
        1: 'dong-bo-hoa-don',
        2: 'phat-hanh-hoa-don',
        3: 'doi-soat',
        4: 'rui-ro-doanh-nghiep',
        5: 'thong-ke',
        6: 'thong-ke',
        7: 'thanh-toan',
      },
    };
  },
  computed: {
    modalWidth() {
      return this.windowWidth * (this.isMobile ? 1 : 0.8);
    },
    imgSize() {
      const factor = this.isMobile ? 0.95 : 1;
      return {
        width: (this.modalWidth * factor) - 32,
        height: this.windowHeight * (this.isMobile ? 0.3 : 0.7),
      };
    },
    isMobile() {
      return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    },
  },
  methods: {
    getGIFUrl(name) {
      return GIF_URL(name);
    },
    setSelected(n) {
      this.selected = n;
    },
    beforeOpen() {
      this.selected = 0;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
$gap: 16px;
$font-size: 18px;
$primary-color: #005DCA;
$rounded: .5rem;

#benefits-modal {
  .modal-body {
    .benefits-container {
      .benefits-top, .benefits-bottom {
        gap: $gap;
        grid-template-rows: auto auto;
        display: grid;

        .item {
          cursor: pointer;
          display: flex;
          gap: $gap;
          flex-direction: column;
          align-items: center;
          justify-content: start;
          position: relative;

          @for $i from 1 through 7 {
            &:nth-child(#{$i}) {
              animation-delay: $i * 0.1s;
            }
          }

          p {
            text-align: center;
            font-weight: 500;
            font-size: $font-size;
            color: $primary-color;
          }

          .image::before {
            position: absolute;
            top: 0;
            left: -90%;
            opacity: 0;
            display: block;
            content: '';
            width: 50%;
            height: 100%;
            background: linear-gradient(to right,rgba(255,255,255,0) 0%,rgba(255,255,255,.3) 100%);
            transform: skewX(-25deg);
            pointer-events: none;
          }
        }

        .item:hover > .image:before {
          animation: shine 1s
        }
      }

      .benefits-top {
        grid-template-columns: repeat(4, minmax(0, 1fr));
        @media (max-width: 1024px) {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        @media (max-width: 768px) {
          grid-template-columns: repeat(1, minmax(0, 1fr));
        }
      }

      .benefits-bottom {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        @media (max-width: 1024px) {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        @media (max-width: 768px) {
          grid-template-columns: repeat(1, minmax(0, 1fr));
        }
      }
    }
    .selected-container {
      display: flex;
      flex-direction: column;
      gap: $gap;
      img {
        border-radius: $rounded;
      }
    }
  }
}
@keyframes shine {
  30% {
    opacity: 1;
  }
  100% {
    left: 125%;
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/notification/benefits-modal.vue